import { NgModule } from '@angular/core';
import { CommonModule as AngularCommon } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PipesModule } from '../../pipes/pipes.module';
import { RadioGroupComponent } from './radio-group.component';
import { RadioComponent } from './radio.component';

@NgModule({
  imports: [
    FormsModule,
    AngularCommon,
    PipesModule,
    RadioGroupComponent,
    RadioComponent
  ],
  exports: [
    RadioGroupComponent,
    RadioComponent
  ]
})
export class RadioModule {
}
